<template>
  <Header />
  <Categories class="hlgd" />

  <NuxtPage />

  <UiScrollTopBtn />

  <Footer />
</template>
<script lang="ts" setup>
</script>
<style scoped></style>
